var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { dataSelectorId, DEFAULT_TEXTS } from './helpers';
import { ACTION_VIEW } from "../../Dialog/types";
import { DialogActions } from "../../Dialog/DialogActions";
import { SPACING_M } from "../../helpers";
import { TodaySvg } from './icons';
var Root = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: ", ";\n"], ["\n    margin-top: ", ";\n"])), SPACING_M);
var MonthSelectorFooter = function (_a) {
    var isApplyMonthSelectorDisabled = _a.isApplyMonthSelectorDisabled, onApplyMonthSelector = _a.onApplyMonthSelector, onCancelMonthSelector = _a.onCancelMonthSelector, onMouseDown = _a.onMouseDown, texts = _a.texts;
    var uiTexts = __assign({ applyMonth: DEFAULT_TEXTS.applyMonth, cancelMonth: DEFAULT_TEXTS.cancelMonth }, texts);
    return (React.createElement(Root, { onMouseDown: onMouseDown },
        React.createElement(DialogActions, { primary: [
                {
                    id: dataSelectorId.applyMonthControl,
                    text: uiTexts.applyMonth,
                    disabled: !isApplyMonthSelectorDisabled,
                    onClick: onApplyMonthSelector
                },
                {
                    id: dataSelectorId.cancelMonthControl,
                    text: uiTexts.cancelMonth,
                    view: ACTION_VIEW.secondary,
                    onClick: onCancelMonthSelector
                }
            ], onMouseDown: onMouseDown })));
};
var MainFooter = function (_a) {
    var isTodayDisabled = _a.isTodayDisabled, onToday = _a.onToday, onApply = _a.onApply, onCancel = _a.onCancel, onMouseDown = _a.onMouseDown, texts = _a.texts;
    var uiTexts = __assign({ today: DEFAULT_TEXTS.today, apply: DEFAULT_TEXTS.apply, cancel: DEFAULT_TEXTS.cancel }, texts);
    return (React.createElement(Root, { onMouseDown: onMouseDown },
        React.createElement(DialogActions, { secondary: [
                {
                    id: dataSelectorId.todayControl,
                    text: uiTexts.today,
                    disabled: isTodayDisabled,
                    iconSrc: React.createElement(TodaySvg, null),
                    view: ACTION_VIEW.text,
                    onClick: onToday
                }
            ], primary: [
                {
                    id: dataSelectorId.applyControl,
                    text: uiTexts.apply,
                    onClick: onApply
                },
                {
                    id: dataSelectorId.cancelControl,
                    text: uiTexts.cancel,
                    view: ACTION_VIEW.secondary,
                    onClick: onCancel
                }
            ], onMouseDown: onMouseDown })));
};
var MainFooterWithOnlyTodayControl = function (_a) {
    var isTodayDisabled = _a.isTodayDisabled, onToday = _a.onToday, onMouseDown = _a.onMouseDown, texts = _a.texts;
    var uiTexts = __assign({ today: DEFAULT_TEXTS.today }, texts);
    return (React.createElement(Root, { onMouseDown: onMouseDown },
        React.createElement(DialogActions, { secondary: [
                {
                    id: dataSelectorId.todayControl,
                    text: uiTexts.today,
                    disabled: isTodayDisabled,
                    iconSrc: React.createElement(TodaySvg, null),
                    view: ACTION_VIEW.text,
                    onClick: onToday
                }
            ], onMouseDown: onMouseDown })));
};
export var Footer = function (_a) {
    var monthSelectMode = _a.monthSelectMode, isTodayDisabled = _a.isTodayDisabled, onToday = _a.onToday, onApply = _a.onApply, onCancel = _a.onCancel, isApplyMonthSelectorDisabled = _a.isApplyMonthSelectorDisabled, onApplyMonthSelector = _a.onApplyMonthSelector, onCancelMonthSelector = _a.onCancelMonthSelector, manualCloseMode = _a.manualCloseMode, withTime = _a.withTime, footerRenderer = _a.footerRenderer, onMouseDown = _a.onMouseDown, texts = _a.texts;
    if (monthSelectMode) {
        return (React.createElement(MonthSelectorFooter, { isApplyMonthSelectorDisabled: isApplyMonthSelectorDisabled, onApplyMonthSelector: onApplyMonthSelector, onCancelMonthSelector: onCancelMonthSelector, onMouseDown: onMouseDown, texts: texts }));
    }
    if (footerRenderer) {
        return (React.createElement(Root, { onMouseDown: onMouseDown }, footerRenderer({
            isTodayDisabled: isTodayDisabled,
            selectToday: onToday,
            apply: onApply,
            cancel: onCancel,
            texts: texts
        })));
    }
    if (manualCloseMode || withTime) {
        return (React.createElement(MainFooter, { isTodayDisabled: isTodayDisabled, onToday: onToday, onApply: onApply, onCancel: onCancel, onMouseDown: onMouseDown, texts: texts }));
    }
    return (React.createElement(MainFooterWithOnlyTodayControl, { isTodayDisabled: isTodayDisabled, onToday: onToday, onMouseDown: onMouseDown, texts: texts }));
};
var templateObject_1;
//# sourceMappingURL=Footer.js.map